<template>
	<v-layout row wrap mb-3>
		<v-flex xs10>
			<v-subheader>{{title}}</v-subheader>
		</v-flex>
		<v-flex xs2 class="d-flex align-center">
			<v-switch
				class="mt-0 pt-0"
				:disabled="disabled"
				v-model="current"
				color="primary"
				hide-details
				@change="$emit('input', current)"
				aria-label="label for switch"
			></v-switch>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: "egrantySwitch",

		data() {
			return {
				current: false,
			};
		},

		watch: {

			value: {
				immediate: true,
				handler(newVal) {
					this.current = newVal;
				},
			},
		},


		props: {
			title: {type: String, default: "Nazwa"},

			value: Boolean,
			disabled: {default: false}
		},

	};
</script>

<style scoped>

</style>
